import React, { Component } from "react";
import { Persist } from "../shared/config";
import { connect } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Router from "../navigation/router";
import { startApp } from "../shared/store/actions/startup";

class Application extends Component {
  componentDidMount() {
    // if redux persist is not active fire startup action
    if (!Persist.active) {
      this.props.startApp();
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Router database={this.props.database} />
      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => ({
  database: state.database
});

export default connect(
  mapStateToProps,
  { startApp }
)(Application);
